// --------------------------------------------------------------
// Created On: 2022-07-27
// Author: Zachary Thomas
//
// Last Modified: 2024-03-06
// Modified By: Jonathon Hicke
//
// Copyright 2024 © Cornell Pump Company, All Rights Reserved
// --------------------------------------------------------------

import React from "react";
import PropTypes from "prop-types";

// A single asset that is pending transfer.
export default function OutgoingTransferAssetListRow(props: Props): Component {
  return (
    <div className="p-2" data-test="outgoing-transfer-row">
      <span>Asset &apos;</span>

      <b>{props.name}</b>

      <span>&apos; is awaiting acceptance from &apos;</span>

      <b>{props.companyName}</b>

      <span>&apos;</span>
    </div>
  );
}

OutgoingTransferAssetListRow.propTypes = {
  assetId: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  companyName: PropTypes.string.isRequired,
};

interface Props {
  assetId: number;
  name: string;
  companyName: string;
}
